var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgBeautySuccess = function SvgBeautySuccess(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2004_60304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C20.68 48 17.56 47.37 14.64 46.11C11.72 44.85 9.18 43.14 7.02 40.98C4.86 38.82 3.15 36.28 1.89 33.36C0.63 30.44 0 27.32 0 24C0 20.68 0.63 17.56 1.89 14.64C3.15 11.72 4.86 9.18 7.02 7.02C9.18 4.86 11.72 3.15 14.64 1.89C17.56 0.63 20.68 0 24 0C27.32 0 30.44 0.63 33.36 1.89C36.28 3.15 38.82 4.86 40.98 7.02C43.14 9.18 44.85 11.72 46.11 14.64C47.37 17.56 48 20.68 48 24C48 27.32 47.37 30.44 46.11 33.36C44.85 36.28 43.14 38.82 40.98 40.98C38.82 43.14 36.28 44.85 33.36 46.11C30.44 47.37 27.32 48 24 48ZM15.48 23.16L20.64 28.32L32.52 16.44C32.96 16 33.52 15.78 34.2 15.78C34.88 15.78 35.44 16 35.88 16.44C36.32 16.88 36.54 17.44 36.54 18.12C36.54 18.8 36.32 19.36 35.88 19.8L22.32 33.36C21.84 33.84 21.28 34.08 20.64 34.08C20 34.08 19.44 33.84 18.96 33.36L12.12 26.52C11.68 26.08 11.46 25.52 11.46 24.84C11.46 24.16 11.68 23.6 12.12 23.16C12.56 22.72 13.12 22.5 13.8 22.5C14.48 22.5 15.04 22.72 15.48 23.16Z",
    fill: "#11D535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.64 28.32L15.48 23.16C15.04 22.72 14.48 22.5 13.8 22.5C13.12 22.5 12.56 22.72 12.12 23.16C11.68 23.6 11.46 24.16 11.46 24.84C11.46 25.52 11.68 26.08 12.12 26.52L18.96 33.36C19.44 33.84 20 34.08 20.64 34.08C21.28 34.08 21.84 33.84 22.32 33.36L35.88 19.8C36.32 19.36 36.54 18.8 36.54 18.12C36.54 17.44 36.32 16.88 35.88 16.44C35.44 16 34.88 15.78 34.2 15.78C33.52 15.78 32.96 16 32.52 16.44L20.64 28.32Z",
    fill: "#064712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2004_60304",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2004_60304"
  })))));
};
export default SvgBeautySuccess;